/*
  Free gift for visitors who arrived via ?subscribesave=1.
  The cookie suu_subscribesave is set in layout/theme.liquid. When that cookie is present and the cart holds a
  Tri-biotics line on a subscription (selling plan), the theme's "Free Product" is added once.
  Config comes from window.suuFreeGift = { variantId, productId } (layout/theme.liquid).
*/
(function () {
  var cfg = window.suuFreeGift;
  if (!cfg || !cfg.variantId) return;
  var SOURCE = 'free-gift-subscribesave';
  // Marks the gift line this script adds, so the same product added by other flows (e.g. with Clear Protein) is never touched
  var PROP = '_suu_subscribesave_gift';
  var busy = false;
  var again = false;

  function fromSubscribeLink() {
    return /(?:^|;\s*)suu_subscribesave=1(?:;|$)/.test(document.cookie);
  }

  function isOurGift(item) {
    console.log('free gift');
    return !!(item.properties && item.properties[PROP]);
  }

  function isTribiotics(item) {
    return /tri-?biotics/i.test(item.handle || '') || /tri-?biotics/i.test(item.product_title || '');
  }

  var SECTIONS = [
    { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
    { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
  ];

  // Paints the drawer and cart bubble the same way cart.js does
  function paint(state) {
    if (!state || !state.sections) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof state.item_count === 'number') drawer.classList.toggle('is-empty', state.item_count === 0);
    SECTIONS.forEach(function (s) {
      var html = state.sections[s.section];
      var host = document.getElementById(s.id);
      if (!html || !host) return;
      var target = host.querySelector(s.selector) || host;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
  }

  // Section HTML returned right after a cart change can lag behind (e.g. a stale item count in a new session),
  // so repaint from the cart as it is now, with a cache-busting fetch per section
  function refresh() {
    return fetch(routes.cart_url + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return Promise.all(
          SECTIONS.map(function (s) {
            return fetch(routes.cart_url + '?section_id=' + s.section + '&_=' + Date.now(), { cache: 'no-store' })
              .then(function (r) { return r.text(); })
              .then(function (html) { return [s.section, html]; });
          })
        ).then(function (pairs) {
          var sections = {};
          pairs.forEach(function (p) { sections[p[0]] = p[1]; });
          paint({ item_count: cart.item_count, sections: sections });
        });
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) {
        console.warn('[free-gift] request failed', url, r.status);
        return false;
      }
      return refresh().then(function () { return true; });
    });
  }

  function check() {
    // A cart change that arrives while a check is running is re-checked once it finishes
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    fetch(routes.cart_url + '.js?_=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var giftLine = items.filter(isOurGift)[0];
        var eligible =
          fromSubscribeLink() &&
          items.some(function (i) {
            return !isOurGift(i) && isTribiotics(i) && i.selling_plan_allocation;
          });

        if (eligible && !giftLine) {
          var properties = {};
          properties[PROP] = '1';
          return post(routes.cart_add_url + '.js', {
            items: [{ id: cfg.variantId, quantity: 1, properties: properties }],
          });
        }

        if (!eligible && giftLine) {
          return post(routes.cart_change_url + '.js', { id: giftLine.key, quantity: 0 });
        }
      })
      .catch(function (e) { console.warn('[free-gift]', e); })
      .then(function () {
        busy = false;
        if (again) {
          again = false;
          check();
        }
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    check();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === SOURCE) return;
        setTimeout(check, 300);
      });
    }
  });
})();
